import { NAME } from "./constants";

export const REMOVE_FUND_WITH_PERCENTAGE_ROW = `${NAME}/REMOVE_FUND_WITH_PERCENTAGE_ROW`;

export const deleteFundWithPercentageRow = (index) => ({
    type: REMOVE_FUND_WITH_PERCENTAGE_ROW,
    meta: { index },
});
